import { useTranslation } from '@eti/providers';
import { secondBaggagePerTraveler } from '@eti/products';
import {
  ADDED_CHECKED_BAGGAGE,
  INFANT_NO_CHECKED_BAGGAGE,
  NO_CHECKED_BAGGAGE,
} from '../../../constants/includedBaggageConstants';
import {
  resolveBaggageForTravelerPaymentCart,
  resolveSecondBagForTravelerPaymentCart,
} from '../../../widgets/cart/utils/baggage';

const checkSummariesFor = (status, summaries = []) =>
  summaries.some((traveler) => traveler.baggageStatus === status);
const getSecondBaggageSelection = (products) =>
  products.find((product) => Number(product.id) === secondBaggagePerTraveler.id) ?? null;

const useAddedCheckInBaggage = (travelers, checkedBaggageSummary = {}, products = []) => {
  const { t } = useTranslation();
  const { tripSummaries } = checkedBaggageSummary;
  const notSelectedLabel = t('Cart.Baggage.Placeholder');
  const hasBaggageBeenAddedToTrip = checkSummariesFor(ADDED_CHECKED_BAGGAGE, tripSummaries);
  const secondBagSelection = getSecondBaggageSelection(products);

  if (!hasBaggageBeenAddedToTrip) {
    return [{ label: notSelectedLabel, noBaggageSelected: true }];
  }

  return travelers.map((traveler) => {
    const travelerBaggageSummary = tripSummaries.find(
      (summary) => summary.travelerId === traveler.id,
    );

    const secondBagSelectionForTraveler =
      secondBagSelection?.travelers.find((selection) => selection.travelerId === traveler.id) || {};

    const { maxWeight: weightSecondBag } = secondBagSelectionForTraveler || {};
    if (travelerBaggageSummary.baggageStatus === NO_CHECKED_BAGGAGE) {
      return {
        label: traveler.name,
        value: notSelectedLabel,
      };
    }

    return {
      label: traveler.name,
      value:
        travelerBaggageSummary.baggageStatus === INFANT_NO_CHECKED_BAGGAGE
          ? t('Cart.Baggage.ContactAirline')
          : resolveBaggageForTravelerPaymentCart(
              t,
              travelerBaggageSummary.baggageDetails,
              secondBagSelectionForTraveler,
            ),

      secondBagValue:
        weightSecondBag && weightSecondBag !== travelerBaggageSummary.baggageDetails.weight
          ? resolveSecondBagForTravelerPaymentCart(t, secondBagSelectionForTraveler)
          : null,
    };
  });
};

export default useAddedCheckInBaggage;
